export default function getResource(label, vars = []) {
    const resources = {
        addToBasketShort: 'Add',
        remove: 'Remove',
        joinToAccess: 'Join to Access',
        signInToAccess: 'Login to Access',
        exclusive: 'Exclusive'
    };
    return resources[label];
}
